<template>
  <div>
    <ca-row>
      <ca-col size="6">
        <ca-field label="Tipo de regime trabalhista">
          <ca-select
            v-model="jobInfo.workingType.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="option in misc.laborRegime"
              :key="option.name"
              :value="option.name">
              {{ option.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Tipo de regime previdenciário">
          <ca-select
            v-model="jobInfo.pensionType.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="option in misc.socialSecurityRegime"
              :key="option.name"
              :value="option.name">
              {{ option.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Aposentadoria Especial">
          <ca-select
            v-model="jobInfo.agentExposureType.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="value in misc.expositionDegree"
              :key="value.name"
              :value="value.name">
              {{ value.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Regime de jornada">
          <ca-select
            v-model="jobInfo.workingHoursType.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="option in misc.regimeJourney"
              :key="option.name"
              :value="option.name">
              {{ option.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Natureza da atividade">
          <ca-select
            v-model="jobInfo.natureActivityWork.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="option in misc.activitiesNature"
              :key="option.name"
              :value="option.name">
              {{ option.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Data base da categoria">
          <ca-input
            v-model="jobInfo.baseDate"
            mask-pattern="99"
            maxlength="2"></ca-input>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Categoria">
          <ca-select
            v-model="jobInfo.category.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="option in misc.workerCategories"
              :key="option.name"
              :value="option.name">
              {{ option.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Vínculo com outra empresa">
          <ca-select
            v-model="jobInfo.anotherCompanyInformation.name"
            required
            :on-change="refreshForm">
            <ca-option
              v-for="option in misc.anotherCompaniesInfo"
              :key="option.name"
              :value="option.name">
              {{ option.description }}
            </ca-option>
          </ca-select>
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row v-if="shouldShowAnotherCompanyInfo">
      <ca-col size="6">
        <ca-field label="CNPJ da outra empresa">
          <ca-input v-model="jobInfo.anotherCompanyRegistration" required></ca-input>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field label="Remuneração na outra empresa">
          <ca-input v-model="jobInfo.anotherCompanySalary" required></ca-input>
        </ca-field>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { hasBondWithAnotherCompany } from './workerInfoJobService';

export default {
  name: 'WorkerJobInfoForm',
  props: {
    jobInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
    shouldShowAnotherCompanyInfo() {
      return hasBondWithAnotherCompany(this.jobInfo.anotherCompanyInformation.name);
    },
  },
  watch: {
    shouldShowAnotherCompanyInfo() {
      this.refreshForm();
    },
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.$store.dispatch('misc/getLaborRegime');
      this.$store.dispatch('misc/getSocialSecurityRegime');
      this.$store.dispatch('misc/getRegimeJourney');
      this.$store.dispatch('misc/getActivitiesNature');
      this.$store.dispatch('misc/getWorkerCategories');
      this.$store.dispatch('misc/getAnotherCompaniesInfo');
      this.$store.dispatch('misc/getExpositionDegree');
    },
    refreshForm() {
      this.$emit('refresh-form');
    },
  },
};
</script>
